import { tableAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
	createMultiStyleConfigHelpers(tableAnatomy.keys);

const primary800 = "primary.800";

const primary = definePartsStyle({
	td: {
		borderY: (theme) => `1px solid ${theme.colors["primary-accent"][500]}`,
	},
	th: {
		py: 4,
	},
	tr: {
		py: 4,
	},
	thead: {
		textColor: "primary-accent.100",
		bgColor: primary800,
	},
	tfoot: {
		textColor: "primary-accent.100",
		bgColor: primary800,
	},
	tbody: {
		textColor: "primary-accent.200",
	},
	table: {
		bgColor: "primary.500",
		rounded: "xl",
		boxShadow: "xl",
		overflow: "hidden",
	},
});

const primaryAccent = definePartsStyle({
	td: {
		borderY: (theme) => `1px solid ${theme.colors.primary[500]}`,
	},
	th: {
		py: 4,
	},
	tr: {
		py: 4,
	},
	thead: {
		textColor: "primary.1000",
		bgColor: "primary-accent.400",
	},
	tfoot: {
		textColor: "primary.1000",
		bgColor: "primary-accent.400",
	},
	tbody: {
		textColor: primary800,
	},
	table: {
		bgColor: "primary-accent.600",
		rounded: "xl",
		boxShadow: "xl",
		overflow: "hidden",
	},
});

export const Table = defineMultiStyleConfig({
	variants: { primary, "primary-accent": primaryAccent },
});
